/* eslint-disable eqeqeq */
import React, { Fragment } from "react";
import PropTypes from "prop-types";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import CircularProgress from "@material-ui/core/CircularProgress";
import { withStyles } from "@material-ui/styles";
import { CardHeader, Grid, Button } from "@material-ui/core";
import {
  IsEmpty,
  getOrderItemStatusColorByStatusId,
} from "../../../../utils/helper";

const useStyles = () => ({
  card: {
    display: "flex",
    flexDirection: "column",
    boxShadow:
      "0 4px 4px 0 rgba(0, 0, 0, 0.2), 0 2px 15px 0 rgba(0, 0, 0, 0.19)",
    //height: "100%",
    borderRadius: 10,
    width: "76%",
    //marginBottom: 40,
    // marginTop: 50,
  },
  image: {
    border: "1px solid #E1E1E1",
    backgroundSize: "contain",
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
    height: 350,
    width: "99%",
  },
  title: {
    color: "#3f51b5",
    display: "flex",
    fontSize: 20,
    marginTop: 5,
    width: "30%",
  },
  imgTitle: {
    fontWeight: 700,
    color: "#3f51b5",
  },
  titleIcon: {
    marginRight: 20,
    fontSize: 28,
  },
  titleDivider: {
    width: "93%",
    backgroundColor: "#3f51b5",
    opacity: "0.5",
    marginLeft: 15,
    marginBottom: 10,
  },
  cardContent: {
    flexGrow: 1,
    padding: 10,
    overflow: "auto",
  },
  imageContainer: {
    flexGrow: 1,
    margin: 10,
  },
  imagePageNo: {
    backgroundColor: "#d9d8d8",
    fontSize: 35,
    fontWeight: 600,
    marginRight: 4,
  },
});

class OrderTab extends React.Component {
  render() {
    const { classes } = this.props;
    let imageContainerHeight = window.screen.height - 420;

    const orderItemStatusId = IsEmpty(this.props.values.selectedSalesData)
      ? 0
      : this.props.values.selectedSalesData.statusId;

    const orderItemStatusLabel = IsEmpty(this.props.values.selectedSalesData)
      ? "N/A"
      : this.props.values.selectedSalesData.statusLabel;
    const minImagesTabHeightValue =
      this.props.values.filterStatus == 1
        ? (62 / 100) * window.innerHeight
        : (70 / 100) * window.innerHeight;

    return (
      <React.Fragment>
        <Card className={classes.card}>
          <CardHeader style={{ padding: 0 }} />
          {/* <Divider className={classes.titleDivider} /> */}
          <CardContent
            style={{
              overflow: "auto",
              maxHeight: minImagesTabHeightValue,
              minHeight: minImagesTabHeightValue,
              padding: 0,
            }}
          >
            <div className={classes.imageContainer}>
              {this.props.values.imagesDataLoading ? (
                <div>
                  <CircularProgress />
                </div>
              ) : (
                <Fragment>
                  {this.props.values.imagesData &&
                    this.props.values.imagesData.length > 0 && (
                      <Fragment>
                        <Grid container spacing={1}>
                          {this.props.values.imagesData.map((card, index) => {
                            if (!card.id) {
                              return (
                                <CardContent className={classes.cardContent} />
                              );
                            } else {
                              return (
                                <Fragment key={card.id || index}>
                                  <Fragment>
                                    <Grid item xs={12}>
                                      <div className={classes.imagePageNo}>
                                        {card.pageNoLabel}
                                      </div>
                                      <div
                                        onClick={() =>
                                          this.props.onImageClick(card)
                                        }
                                        className={classes.image}
                                        style={{
                                          backgroundImage: `url('${process.env.REACT_APP_API_DOMAIN}/${process.env.REACT_APP_SUB_API_NAME}/albums/C01ImageView?fileName=${card.thumnailFileName}')`,
                                          height: imageContainerHeight,
                                          cursor: "pointer",
                                        }}
                                      />
                                    </Grid>
                                  </Fragment>
                                </Fragment>
                              );
                            }
                          })}
                          <Grid
                            item
                            xs={12}
                            style={{ marginTop: 10, marginBottom: 10 }}
                          >
                            {orderItemStatusId != 1 &&
                            orderItemStatusId != 13 ? (
                              <Button
                                disabled
                                style={{
                                  cursor: "default",
                                  color:
                                    getOrderItemStatusColorByStatusId(
                                      orderItemStatusId
                                    ),
                                  border: `1px solid ${getOrderItemStatusColorByStatusId(
                                    orderItemStatusId
                                  )}`,
                                }}
                                variant="outlined"
                              >
                                {orderItemStatusLabel}
                              </Button>
                            ) : (
                              <Fragment>
                                {orderItemStatusId == 13 ? (
                                  <>
                                    <Button
                                      style={{
                                        marginRight: 10,
                                        textTransform: "capitalize",
                                      }}
                                      variant="contained"
                                      color="primary"
                                      disabled={
                                        this.props.values
                                          .onConfirmItemStatusLoading ||
                                        this.props.values
                                          .onCancelItemStatusLoading ||
                                        orderItemStatusId == 2 ||
                                        orderItemStatusId == 3
                                      }
                                      onClick={() => this.props.sendToQA(11)}
                                    >
                                      {this.props.values
                                        .onConfirmItemStatusLoading ? (
                                        <CircularProgress
                                          color="primary"
                                          size={24}
                                        />
                                      ) : (
                                        `${
                                          orderItemStatusId == 13
                                            ? "Send to Production QA"
                                            : "Sent to Production QA"
                                        }`
                                      )}
                                    </Button>

                                    <Button
                                      style={{
                                        marginRight: 10,
                                        textTransform: "capitalize",
                                      }}
                                      variant="contained"
                                      color="primary"
                                      disabled={
                                        this.props.values
                                          .onConfirmItemStatusLoading ||
                                        this.props.values
                                          .onCancelItemStatusLoading ||
                                        orderItemStatusId == 2 ||
                                        orderItemStatusId == 3
                                      }
                                      onClick={() => this.props.sendToQA(4)}
                                    >
                                      {this.props.values
                                        .onConfirmItemStatusLoading ? (
                                        <CircularProgress
                                          color="primary"
                                          size={24}
                                        />
                                      ) : (
                                        `${
                                          orderItemStatusId == 13
                                            ? "Send to Printing QA"
                                            : "Sent to Printing QA"
                                        }`
                                      )}
                                    </Button>
                                  </>
                                ) : (
                                  <>
                                    <Button
                                      style={{
                                        marginRight: 10,
                                        textTransform: "capitalize",
                                      }}
                                      variant="contained"
                                      color="primary"
                                      disabled={
                                        this.props.values
                                          .onConfirmItemStatusLoading ||
                                        this.props.values
                                          .onCancelItemStatusLoading ||
                                        orderItemStatusId == 2 ||
                                        orderItemStatusId == 3
                                      }
                                      onClick={() =>
                                        this.props.onImagesConfirmationClick(2)
                                      }
                                    >
                                      {this.props.values
                                        .onConfirmItemStatusLoading ? (
                                        <CircularProgress
                                          color="primary"
                                          size={24}
                                        />
                                      ) : (
                                        `${
                                          orderItemStatusId == 10
                                            ? "Confirmed"
                                            : "Confirm"
                                        }`
                                      )}
                                    </Button>
                                    <Button
                                      style={{
                                        marginLeft: 10,
                                        textTransform: "capitalize",
                                      }}
                                      variant="contained"
                                      color="default"
                                      disabled={
                                        this.props.values
                                          .onConfirmItemStatusLoading ||
                                        this.props.values
                                          .onCancelItemStatusLoading ||
                                        orderItemStatusId == 2 ||
                                        orderItemStatusId == 3
                                      }
                                      onClick={() =>
                                        this.props.toggleChangeStatusDialog()
                                      }
                                    >
                                      {orderItemStatusId == 3
                                        ? "Cancelled"
                                        : "Cancel"}
                                    </Button>
                                  </>
                                )}
                              </Fragment>
                            )}
                          </Grid>
                        </Grid>
                      </Fragment>
                    )}
                </Fragment>
              )}
            </div>
          </CardContent>
        </Card>
      </React.Fragment>
    );
  }
}

OrderTab.propTypes = {
  classes: PropTypes.object.isRequired,
  values: PropTypes.object,
  onImageClick: PropTypes.func,
  downloadImagesData: PropTypes.func,
  downloadPdfImagesData: PropTypes.func,
  printBarcode: PropTypes.func,
  onImagesConfirmationClick: PropTypes.func,
  toggleChangeStatusDialog: PropTypes.func,
};

OrderTab.defaultProps = {
  values: {},
  onImageClick: (fn) => fn,
  downloadImagesData: (fn) => fn,
  downloadPdfImagesData: (fn) => fn,
  onImagesConfirmationClick: (fn) => fn,
  printBarcode: (fn) => fn,
  toggleChangeStatusDialog: (fn) => fn,
};

export default withStyles(useStyles)(OrderTab);
